import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let eventsSwiperWr = document.querySelectorAll('.events-swiper-wr');
eventsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let loop = false;
    let loopedSlides = false;
    let isReverse = swiperEl.classList.contains('reverse-direction');
    let breakpoints = {
      480: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 18,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 26,
      },
    };

    if (el.classList.contains('gallery-sec__slider')) {
      loop = slidesCount >= 6;
      loopedSlides = slidesCount >= 6 ? slidesCount * 3 : false;
      breakpoints = {
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      }
    }
    

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 14,
      slidesPerView: 1,
      loop: loop,
      loopedSlides: loopedSlides,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: breakpoints,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 640,
        reverseDirection: isReverse,
      },
    });
    swiperObserver(swiper);

    if(isReverse) {
      swiper.slideTo(swiper.slides.length)
    }
  }
});

const tagsContainer = document.querySelector('.our-events__tags');


if (tagsContainer) {
  const tags = tagsContainer.querySelectorAll('.our-events__tag');
  function activateTagsSequentially() {
    tags.forEach((tag, index) => {
      setTimeout(() => {
        tag.classList.add('active');
      }, index * 300);
    });
  }

  const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        tagsContainer.classList.contains('animated')
      ) {
        activateTagsSequentially();
        observer.disconnect();
        break;
      }
    }
  });

  observer.observe(tagsContainer, {
    attributes: true,
    attributeFilter: ['class']
  });
}

